module.exports = __webpack_public_path__ + "static/media/btn-score-table.8532a8d6.png";